import { SidePanel } from '@/components/SidePanel/SidePanel';
import { ResetPasswordForm } from './components/reset-password-form';
import IntlMessages from '@/components/utility/intlMessages';
import { useSearchParams } from 'react-router-dom';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();

  return (
    <div className="grid grid-cols-1 md:grid-cols-[35%_1fr] h-[calc(100vh-70.22px)] overflow-hidden">
      <div className="overflow-y-auto">
        <div className="flex flex-col gap-y-5 m-6 md:m-10 py-10">
          <h3 className="text-xl">
            <IntlMessages id="page.forgotPasswordTitle" />
          </h3>
          <p>
            <IntlMessages id="page.forgotPasswordParagraph" />
          </p>
          <ResetPasswordForm code={searchParams.get('code')} />
        </div>
      </div>
      <div className="md:shadow-[inset_rgba(0,0,0,0.05)_0px_4px_10px_0px] overflow-y-auto h-full">
        <SidePanel />
      </div>
    </div>
  );
}
